import Vue from 'vue';
import SvgIcon from './index.vue'; // svg组件

// register globally
Vue.component('svg-icon', SvgIcon);

const req = require.context('./svg-doc', false, /\.svg$/);
const requireAll = (requireContext) => requireContext.keys().map(requireContext);
requireAll(req);



// WEBPACK FOOTER //
// ./src/components/game/common-component/svg-icon/index.js